module.exports = __webpack_public_path__ + "static/media/image_danye.02bc72a5.png";